export enum VotingStatus {
  UNKNOWN = 'unknown',
  COMING_SOON = 'comingSoon',
  ONGOING = 'onGoing',
  ENDED = 'ended',
  RESULTS_READY = 'resultsReady',
}
